<div class="aca-admin aca-groups">
  <aca-page-header [bare]="embedded" icon="groups" [title]="'DMS.GROUPS_PAGE.405883' | translate" [subtitle]="'DMS.UI.F09C09' | translate">
    <button type="button" class="aca-groups__primary" (click)="createGroup()" [disabled]="working()">
      <mat-icon>group_add</mat-icon>{{ 'DMS.GROUPS_PAGE.398170' | translate }}
    </button>
  </aca-page-header>

  <!-- ── summary ────────────────────────────────────────────────────────── -->
  <div class="aca-groups__stats" *ngIf="!failed()">
    <div class="aca-groups__stat">
      <span class="aca-groups__staticon aca-groups__staticon--blue"><mat-icon>groups</mat-icon></span>
      <span class="aca-groups__stattext">
        <span class="aca-groups__statlabel">{{ 'DMS.GROUPS_PAGE.0CEA97' | translate }}</span>
        <span class="aca-groups__statvalue">{{ totalCount() }}</span>
        <span class="aca-groups__statunit">{{ 'DMS.GROUPS_PAGE.4898F3' | translate }}</span>
      </span>
    </div>

    <div class="aca-groups__stat">
      <span class="aca-groups__staticon aca-groups__staticon--purple"><mat-icon>account_tree</mat-icon></span>
      <span class="aca-groups__stattext">
        <span class="aca-groups__statlabel">{{ 'DMS.GROUPS_PAGE.60FD25' | translate }}</span>
        <span class="aca-groups__statvalue">{{ rootCount() }}</span>
        <span class="aca-groups__statunit">{{ 'DMS.GROUPS_PAGE.4898F3' | translate }}</span>
      </span>
    </div>

    <div class="aca-groups__stat">
      <span class="aca-groups__staticon aca-groups__staticon--green"><mat-icon>workspaces</mat-icon></span>
      <span class="aca-groups__stattext">
        <span class="aca-groups__statlabel">{{ 'DMS.GROUPS_PAGE.A48A6D' | translate }}</span>
        <span class="aca-groups__statvalue">{{ siteCount() }}</span>
        <span class="aca-groups__statunit">{{ 'DMS.GROUPS_PAGE.4898F3' | translate }}</span>
      </span>
    </div>

    <div class="aca-groups__stat">
      <span class="aca-groups__staticon aca-groups__staticon--amber"><mat-icon>subdirectory_arrow_right</mat-icon></span>
      <span class="aca-groups__stattext">
        <span class="aca-groups__statlabel">{{ 'DMS.GROUPS_PAGE.675265' | translate }}</span>
        <span class="aca-groups__statvalue">{{ nestedCount() }}</span>
        <span class="aca-groups__statunit">{{ 'DMS.GROUPS_PAGE.4898F3' | translate }}</span>
      </span>
    </div>
  </div>

  <!-- ── filters ────────────────────────────────────────────────────────── -->
  <div class="aca-groups__filterbar">
    <form class="aca-groups__searchfilter" (submit)="$event.preventDefault(); applyFilters()">
      <mat-icon>search</mat-icon>
      <input
        type="text"
        data-automation-id="dms-groups-search"
        [placeholder]="'DMS.GROUPS_PAGE.ABC840' | translate"
        [(ngModel)]="term"
        name="term"
        (ngModelChange)="applyFilters()"
        autocomplete="off"
      />
    </form>

    <label class="aca-groups__filter">
      <span class="aca-groups__filterlabel">{{ 'DMS.GROUPS_PAGE.32EF30' | translate }}</span>
      <select class="aca-groups__select" [(ngModel)]="kind" name="kind" (ngModelChange)="applyFilters()">
        <option value="all">{{ 'DMS.GROUPS_PAGE.56EFFD' | translate }}</option>
        <option value="directory">{{ 'DMS.GROUPS_PAGE.9110F2' | translate }}</option>
        <option value="site">{{ 'DMS.GROUPS_PAGE.A48A6D' | translate }}</option>
        <option value="root">{{ 'DMS.GROUPS_PAGE.60FD25' | translate }}</option>
      </select>
    </label>

    <button type="button" class="aca-groups__link" (click)="clearFilters()">{{ 'DMS.GROUPS_PAGE.1C5830' | translate }}</button>
    <span class="aca-groups__count"
      >{{ 'DMS.UI.1D31FB' | translate }} {{ visibleGroups().length }} {{ 'DMS.UI.F2DB2C' | translate }} {{ totalCount() }}
      {{ 'DMS.UI.A42B89' | translate }}</span
    >
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading() || working()" />

  <aca-page-state
    *ngIf="failed()"
    state="error"
    [title]="'DMS.GROUPS_PAGE.AC570B' | translate"
    [message]="failed()"
    [actionLabel]="'DMS.UI.324E7E' | translate"
    (action)="reload()"
  />

  <!-- ── table + detail ─────────────────────────────────────────────────── -->
  <div class="aca-groups__body" [class.aca-groups__body--split]="selected()" *ngIf="!failed()">
    <section class="aca-groups__card">
      <aca-page-state
        *ngIf="!loading() && !visibleGroups().length"
        state="empty"
        icon="groups"
        [title]="'DMS.GROUPS_PAGE.93BC66' | translate"
        [message]="'DMS.UI.61AE4B' | translate"
        [actionLabel]="'DMS.UI.864B57' | translate"
        (action)="clearFilters()"
      />

      <div class="aca-groups__tablewrap" *ngIf="visibleGroups().length">
        <table class="aca-groups__table">
          <thead>
            <tr>
              <th class="aca-groups__th aca-groups__th--name">{{ 'DMS.GROUPS_PAGE.A7A4D4' | translate }}</th>
              <th class="aca-groups__th">{{ 'DMS.GROUPS_PAGE.5E1D1A' | translate }}</th>
              <th class="aca-groups__th">{{ 'DMS.GROUPS_PAGE.AEABC8' | translate }}</th>
              <th class="aca-groups__th">{{ 'DMS.GROUPS_PAGE.43AD7E' | translate }}</th>
              <th class="aca-groups__th">{{ 'DMS.GROUPS_PAGE.9AF498' | translate }}</th>
              <th class="aca-groups__th aca-groups__th--actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="aca-groups__row"
              *ngFor="let group of visibleGroups(); trackBy: trackById"
              [class.aca-groups__row--on]="selected()?.id === group.id"
              [attr.data-automation-id]="'dms-groups-row-' + group.id"
              (click)="select(group)"
            >
              <td class="aca-groups__td aca-groups__td--name">
                <span class="aca-groups__icon" [class.aca-groups__icon--site]="group.isSiteGroup">
                  <mat-icon>{{ group.isSiteGroup ? 'workspaces' : 'groups' }}</mat-icon>
                </span>
                <span class="aca-groups__name">{{ group.displayName }}</span>
              </td>
              <td class="aca-groups__td">
                <code class="aca-groups__code">{{ group.id }}</code>
              </td>
              <td class="aca-groups__td">
                <span class="aca-groups__chip" [class.aca-groups__chip--site]="group.isSiteGroup">{{ kindLabel(group) | translate }}</span>
              </td>
              <td class="aca-groups__td">{{ levelLabel(group) }}</td>
              <td class="aca-groups__td">
                <span class="aca-groups__members">
                  <mat-icon>person</mat-icon>
                  {{ memberText(group) }}
                </span>
              </td>
              <td class="aca-groups__td aca-groups__td--actions">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="rowMenu"
                  (click)="$event.stopPropagation()"
                  [matTooltip]="'DMS.GROUPS_PAGE.4548F8' | translate"
                  [attr.aria-label]="'DMS.GROUPS_PAGE.4548F8' | translate"
                >
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #rowMenu="matMenu">
                  <button mat-menu-item (click)="select(group)">
                    <mat-icon>groups</mat-icon><span>{{ 'DMS.GROUPS_PAGE.43BFB1' | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="rename(group)">
                    <mat-icon>edit</mat-icon><span>{{ 'DMS.GROUPS_PAGE.685CBB' | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="addMember(group)">
                    <mat-icon>person_add</mat-icon><span>{{ 'DMS.GROUPS_PAGE.D55267' | translate }}</span>
                  </button>
                  <button mat-menu-item class="aca-groups__dangeritem" (click)="deleteGroup(group)">
                    <mat-icon>delete</mat-icon><span>{{ 'DMS.GROUPS_PAGE.59AF33' | translate }}</span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- ── detail panel ─────────────────────────────────────────────────── -->
    <aside class="aca-groups__panel" *ngIf="selected() as group">
      <header class="aca-groups__panelhead">
        <h2 class="aca-groups__paneltitle">{{ 'DMS.GROUPS_PAGE.646334' | translate }}</h2>
        <button
          mat-icon-button
          (click)="closePanel()"
          [matTooltip]="'DMS.GROUPS_PAGE.96D79D' | translate"
          [attr.aria-label]="'DMS.GROUPS_PAGE.96D79D' | translate"
        >
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <div class="aca-groups__identity">
        <span class="aca-groups__icon aca-groups__icon--lg" [class.aca-groups__icon--site]="group.isSiteGroup">
          <mat-icon>{{ group.isSiteGroup ? 'workspaces' : 'groups' }}</mat-icon>
        </span>
        <div class="aca-groups__identitytext">
          <span class="aca-groups__identityname">{{ group.displayName }}</span>
          <code class="aca-groups__code">{{ group.id }}</code>
        </div>
      </div>

      <dl class="aca-groups__props">
        <dt>{{ 'DMS.GROUPS_PAGE.213D69' | translate }}</dt>
        <dd>{{ kindLabel(group) | translate }}</dd>

        <dt>{{ 'DMS.GROUPS_PAGE.43AD7E' | translate }}</dt>
        <dd>{{ levelLabel(group) }}</dd>

        <dt>Authority zone</dt>
        <dd>{{ group.zones.join(', ') || '—' }}</dd>

        <dt>{{ 'DMS.GROUPS_PAGE.0525FB' | translate }}</dt>
        <dd>{{ memberText(group) }}</dd>
      </dl>

      <section class="aca-groups__members-section">
        <h3 class="aca-groups__memberstitle">
          {{ 'DMS.GROUPS_PAGE.A76700' | translate
          }}<button type="button" class="aca-groups__link" (click)="addMember(group)">{{ 'DMS.GROUPS_PAGE.D55267' | translate }}</button>
        </h3>

        <p class="aca-groups__loading" *ngIf="membersLoading()">{{ 'DMS.GROUPS_PAGE.D14A5E' | translate }}</p>

        <ul class="aca-groups__memberlist" *ngIf="!membersLoading()">
          <li class="aca-groups__member" *ngFor="let member of members(); trackBy: trackByMemberId">
            <span class="aca-groups__avatar" [class.aca-groups__avatar--group]="member.isGroup">
              <mat-icon *ngIf="member.isGroup">groups</mat-icon>
              <ng-container *ngIf="!member.isGroup">{{ initials(member.displayName) }}</ng-container>
            </span>
            <span class="aca-groups__memberbox">
              <span class="aca-groups__membername">{{ member.displayName }}</span>
              <span class="aca-groups__membertype">{{ member.isGroup ? ('DMS.UI.C6C0C3' | translate) : ('DMS.UI.F12543' | translate) }}</span>
            </span>
            <button
              mat-icon-button
              (click)="removeMember(group, member)"
              [matTooltip]="'DMS.GROUPS_PAGE.F76714' | translate"
              [attr.aria-label]="'DMS.GROUPS_PAGE.F76714' | translate"
            >
              <mat-icon>close</mat-icon>
            </button>
          </li>
          <li class="aca-groups__memberempty" *ngIf="!members().length">{{ 'DMS.GROUPS_PAGE.1E9065' | translate }}</li>
        </ul>
      </section>

      <div class="aca-groups__panelactions">
        <button type="button" class="aca-groups__outline" (click)="rename(group)">
          <mat-icon>edit</mat-icon>{{ 'DMS.GROUPS_PAGE.685CBB' | translate }}
        </button>
        <button type="button" class="aca-groups__danger" data-automation-id="dms-groups-delete" (click)="deleteGroup(group)">
          <mat-icon>delete</mat-icon>{{ 'DMS.GROUPS_PAGE.59AF33' | translate }}
        </button>
      </div>
    </aside>
  </div>
</div>
